import React from 'react';
import { Table, Form, Button, Card } from 'react-bootstrap';
import './HarbourProjectsTable.css';

const HarbourProjectsTable = ({
  rows = [],
  currentPage,
  totalPages,
  totalRows,
  rowsPerPage,
  onRowsPerPageChange,
  onPrevPage,
  onNextPage,
  startIndex,
  endIndex,
  onOpenCarousel,
  sortColumn,
  sortDirection,
  onSort,
}) => {
  const getSortArrow = (columnKey) => {
    if (sortColumn === columnKey) {
      return sortDirection === 'asc' ? ' ↑' : ' ↓';
    }
    return '';
  };
  const renderBadge = (row) => {
    if (row.actuatorReplaced === true) {
      return <span className="harbour-status-badge positive">YES</span>;
    }
    if (row.actuatorReplaced === false) {
      return <span className="harbour-status-badge negative">NO</span>;
    }
    return <span className="harbour-status-badge negative">Missed Unit</span>;
  };

  const renderPhotoThumbs = (row) => {
    const beforeList = (row.actuatorBeforePhotos || []).filter(Boolean);
    const afterList = (row.actuatorAfterPhotos || []).filter(Boolean);
    const combined = [...beforeList, ...afterList];

    if (row.actuatorReplaced === true && combined.length > 0) {
      return (
        <div className="harbour-photo-group">
          <div
            className="harbour-thumb"
            onClick={() => onOpenCarousel(combined, 0, row.photoLabelMap)}
          >
            {beforeList.length > 0 ? (
              <img src={beforeList[0]} alt="Before" className="harbour-thumb-image" />
            ) : (
              <div className="harbour-thumb-placeholder-block">No Photo</div>
            )}
            <span className="harbour-thumb-label">Before</span>
          </div>
          <div
            className="harbour-thumb"
            onClick={() =>
              onOpenCarousel(combined, beforeList.length > 0 ? beforeList.length : 0, row.photoLabelMap)
            }
          >
            {afterList.length > 0 ? (
              <img src={afterList[0]} alt="After" className="harbour-thumb-image" />
            ) : (
              <div className="harbour-thumb-placeholder-block">No Photo</div>
            )}
            <span className="harbour-thumb-label">After</span>
          </div>
        </div>
      );
    }

    const valvePhotos = (row.badValvesPhotos || []).filter(Boolean);
    if (valvePhotos.length > 0) {
      return (
        <div
          className="harbour-thumb single"
          onClick={() => onOpenCarousel(valvePhotos, 0, row.photoLabelMap)}
        >
          <img src={valvePhotos[0]} alt="Valve Issue" className="harbour-thumb-image" />
          <span className="harbour-thumb-label">Valve Issue</span>
        </div>
      );
    }

    return <span className="harbour-thumb-placeholder">No Photo</span>;
  };

  const renderIssuePhoto = (row) => {
    if (!row.mouldPresent) {
      return <span className="harbour-thumb-placeholder">No Photo</span>;
    }
    const mouldPhotos = (row.harbourMouldPhotos || []).filter(Boolean);
    if (!mouldPhotos.length) {
      return <span className="harbour-thumb-placeholder">No Photo</span>;
    }
    return (
      <div
        className="harbour-thumb single"
        onClick={() => onOpenCarousel(mouldPhotos, 0, row.photoLabelMap)}
      >
        <img src={mouldPhotos[0]} alt="Potential Mould" className="harbour-thumb-image" />
        <span className="harbour-thumb-label">Potential Mould</span>
      </div>
    );
  };

  return (
    <div className="harbour-table-wrapper">
      <Card className="shadow-sm border-0 fancoil-table-card">
        <Card.Body style={{ padding: 0 }}>
          <Table hover responsive className="fancoil-table harbour-table mb-0 border-0">
            <thead>
              <tr>
                <th className="clickable-th" onClick={() => onSort?.('unit')}>Unit # {getSortArrow('unit')}</th>
                <th className="clickable-th" onClick={() => onSort?.('inspectionDate')}>Inspection Date {getSortArrow('inspectionDate')}</th>
                <th className="clickable-th" onClick={() => onSort?.('equipmentLocation')}>Location {getSortArrow('equipmentLocation')}</th>
                <th className="clickable-th" onClick={() => onSort?.('actuatorReplaced')}>Actuator &amp; Valves Replaced? {getSortArrow('actuatorReplaced')}</th>
                <th>Photos</th>
                <th className="clickable-th" onClick={() => onSort?.('mouldPresent')}>Additional Issues {getSortArrow('mouldPresent')}</th>
                <th>Issue Photo</th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 ? (
                <tr>
                  <td colSpan={7} style={{ textAlign: 'center', padding: '2rem 0' }}>
                    No project data available.
                  </td>
                </tr>
              ) : (
                rows.map((row) => (
                  <tr key={row.objectId || row.unit}>
                    <td>{row.unit || '—'}</td>
                    <td>{row.inspectionDate || '—'}</td>
                    <td>{row.equipmentLocation || row.location || '—'}</td>
                    <td>{renderBadge(row)}</td>
                    <td>{renderPhotoThumbs(row)}</td>
                    <td>
                      {row.mouldPresent ? (
                        <span className="harbour-mould-flag">POTENTIAL MOULD</span>
                      ) : (
                        'No Issues'
                      )}
                    </td>
                    <td>{renderIssuePhoto(row)}</td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
      <div className="harbour-pagination">
        <div className="harbour-pagination__left">
          <span className="me-2">Rows per page:</span>
          <Form.Select
            value={rowsPerPage}
            onChange={(e) => onRowsPerPageChange(e.target.value)}
            style={{ width: 'auto' }}
          >
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="25">25</option>
          </Form.Select>
          <span className="ms-3">
            Showing {totalRows === 0 ? 0 : startIndex + 1} to {endIndex} of {totalRows}
          </span>
        </div>
        <div className="harbour-pagination__right">
          <span className="me-3">Page {currentPage} of {totalPages}</span>
          <Button variant="outline-secondary" size="sm" className="me-2" onClick={onPrevPage} disabled={currentPage === 1}>
            Previous
          </Button>
          <Button variant="outline-secondary" size="sm" onClick={onNextPage} disabled={currentPage >= totalPages}>
            Next
          </Button>
        </div>
      </div>
    </div>
  );
};

export default HarbourProjectsTable;

